import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { config } from '../services/api';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <div className="footer-content row">
          <Col lg={4} md={6} className="mb-4 mb-md-0">
            <div className="footer-about">
              <img src={`${config.MEDIA_URL}/logos/logo.png`} alt="Delta X Logo" className="footer-logo mb-4" />
              <p>Nous croyons en un tourisme d'aventure authentique et sur mesure pour vous offrir des expériences uniques et inoubliables avec des experts locaux.</p>
            </div>
          </Col>
          <Col lg={4} md={6} className="mb-4 mb-md-0">
            <div className="footer-links">
              <h4 className="footer-title">Liens Rapides</h4>
              <ul>
                <li><a href="/" data-discover="true"><i className="fas fa-chevron-right"></i> Accueil</a></li>
                <li><a href="/about" data-discover="true"><i className="fas fa-chevron-right"></i> DELTA X</a></li>
                <li><a href="/evenements" data-discover="true"><i className="fas fa-chevron-right"></i> Evenements</a></li>
                <li><a href="/contact" data-discover="true"><i className="fas fa-chevron-right"></i> Contact</a></li>
              </ul>
            </div>
          </Col>
          <Col lg={4} md={6}>
            <div className="footer-contact">
              <h4 className="footer-title">Contactez-nous</h4>
              <ul>
                <li><i className="fas fa-map-marker-alt"></i><span>Université de Boumerdès, Algérie</span></li>
                <li><i className="fas fa-envelope"></i><span>contact@deltax.com</span></li>
                <li><i className="fas fa-phone"></i><span>+213 XX XX XX XX</span></li>
              </ul>
              <div className="social-links mt-4">
                <a href="#" className="social-icon"><i className="fab fa-facebook-f"></i></a>
                <a href="#" className="social-icon"><i className="fab fa-twitter"></i></a>
                <a href="#" className="social-icon"><i className="fab fa-instagram"></i></a>
                <a href="#" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>
          </Col>
        </div>
        <Row>
          <Col className="text-center footer-bottom">
            <p>© {new Date().getFullYear()} DELTA X. Tous droits réservés.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;